/**
 * MarkdownFormat Component
 * 
 * Supports markdown, links, line breaks
 * Renders markdown content with theme-aware styling
 */
import React from 'react';
import { marked } from 'marked';

const MarkdownFormat = ({ content }) => {
  const formatContent = (content) => {
    if (!content) return '';
    
    // Create marked renderer
    const renderer = new marked.Renderer();
    
    // Customize link renderer to open in new tab
    renderer.link = function ({ href, text }) {
      return `<a href="${href}" target="_blank" rel="noopener noreferrer">${text}</a>`;
    };
    
    // Configure marked with renderer and breaks option
    marked.setOptions({
      renderer,
      breaks: true
    });
    
    // Parse content to HTML
    const html = marked.parse(content);
    
    return html;
  };

  return (
    <div
      style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: 'clamp(1rem, 4vw, 2rem)',
        background: 'var(--theme-surface, #f8f9fa)',
        borderRadius: 12,
        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
        border: '1px solid var(--theme-border, #dee2e6)',
        textAlign: 'left',
        color: 'var(--theme-text, #212529)',
        overflow: 'auto',
      }}
      className="markdown-content"
      dangerouslySetInnerHTML={{ __html: formatContent(content) }}
    />
  );
};

export default MarkdownFormat;
